export default function truncateString(str, maxLen = 25) {
  return str?.length > maxLen ? str.slice(0, maxLen - 1) + '...' : str
}
